import PropTypes from 'prop-types';

import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';
import {
  IsLoadingDefaultProps,
  IsLoadingPropTypes,
} from '@/common/proptypes/Base/IsLoading.proptypes';

export const ListActionDefaultProps = {
  ...DisabledDefaultProps,
  ...IsLoadingDefaultProps,
  delivered: false,
  deliveryNotes: [],
  id: null,
  isShippingAvailable: false,
  origin: null,
  reference: null,
  shippingType: {},
  status: {},
};

export const ListActionPropTypes = {
  ...DisabledPropTypes,
  ...IsLoadingPropTypes,
  delivered: PropTypes.bool,
  deliveryNotes: PropTypes.arrayOf(PropTypes.number),
  id: PropTypes.number,
  isShippingAvailable: PropTypes.bool,
  origin: PropTypes.string,
  reference: PropTypes.string,
  shippingType: PropTypes.shape({
    id: PropTypes.string,
  }),
  status: PropTypes.shape({
    code: PropTypes.string,
    label: PropTypes.string,
  }),
};
